(function(){
  /* A&M cart: every add / quantity change / remove is ONE request that also returns the new drawer HTML (Shopify bundled section rendering). */
  var SID='am-cart-boost',boostHTML=null,count=0,keepTop=0,mseq=0,applied=0,loading=false,again=false,pend={},qt=0,inflight=false;
  var st=document.createElement('style');st.textContent='.amk--sync .amk-save,.amk--sync .amk-mile,.amk--sync .amk-offers,.amk--sync .amk-bill,.amk--sync .amk__total{opacity:.5;transition:opacity .15s}';document.head.appendChild(st);
  function ids(){var s=[SID];document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(c){var i=c.getAttribute('data-section-id');if(i&&s.indexOf(i)<0&&s.length<5)s.push(i)});return s}
  function post(url,data){
    data.sections=ids().join(',');data.sections_url=window.location.pathname;
    return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)}).then(function(r){return r.json().then(function(j){if(!r.ok||j.status)throw j;return j})});
  }
  function cur(){return document.querySelector('.cart-drawer__inner>.amk')}
  function parse(h){var w=document.createElement('div');w.innerHTML=h||'';var b=w.querySelector('.amk');if(!b)return false;var n=b.querySelector('.amk__title span');count=n?parseInt(n.textContent,10)||0:0;boostHTML=b.outerHTML;return true}
  function place(){
    var dlg=document.querySelector('.cart-drawer__dialog');if(!dlg||!boostHTML)return;
    var inner=dlg.querySelector('.cart-drawer__inner');if(!inner||inner.querySelector(':scope>.amk'))return;
    var w=document.createElement('div');w.innerHTML=boostHTML;var el=w.querySelector('.amk');if(!el)return;
    inner.appendChild(el);var b=el.querySelector('.amk__body');if(b&&keepTop)b.scrollTop=keepTop;
  }
  function refresh(){var o=cur(),b=o&&o.querySelector('.amk__body');if(b)keepTop=b.scrollTop;document.querySelectorAll('.cart-drawer__inner>.amk').forEach(function(x){x.remove()});place()}
  function emit(res,secs,n,id){var e=new Event('cart:update',{bubbles:true});e.detail={resource:res,sourceId:'am-add',data:{source:'am-add',itemCount:n,variantId:String(id||''),sections:secs}};document.dispatchEvent(e)}
  function run(url,data,id){
    var my=++mseq;
    return post(url,data).then(function(j){
      if(my<applied)return j;applied=my;
      var secs=j.sections||{},ok=parse(secs[SID]);
      var o=cur(),b=o&&o.querySelector('.amk__body');if(b)keepTop=b.scrollTop;
      emit(j,secs,typeof j.item_count==='number'?j.item_count:count,id);
      if(ok)refresh();else load();
      return j;
    });
  }
  window.amAdd=function(id,btn){
    var t=btn?btn.textContent:'',q=btn?(+btn.getAttribute('data-am-qty')||1):1;
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    return run('/cart/add.js',{items:[{id:+id,quantity:q}]},id).then(function(){
      var d=document.querySelector('cart-drawer-component');if(d&&typeof d.open==='function')d.open();
      if(btn){btn.textContent='Added ✓';setTimeout(function(){btn.disabled=false;btn.textContent=t;},1500);}
    }).catch(function(err){if(btn){btn.disabled=false;btn.textContent=t;}console.error(err);});
  };
  /* quantity: the number changes on tap, quick taps are sent together */
  function setQ(it,q){it.setAttribute('data-q',q);var s=it.querySelector('.amk-qty span');if(s)s.textContent=q}
  function mark(){var o=cur();if(o)o.classList.add('amk--sync')}
  function queue(key,q,now){pend[key]=q;mark();clearTimeout(qt);qt=setTimeout(flush,now?0:250)}
  function flush(){
    if(inflight){qt=setTimeout(flush,120);return}
    var u=pend;if(!Object.keys(u).length)return;pend={};inflight=true;
    run('/cart/update.js',{updates:u},'').catch(function(e){console.error(e);load()}).then(function(){
      inflight=false;
      for(var k in pend){var it=document.querySelector('.cart-drawer__inner>.amk .amk-item[data-key="'+(window.CSS&&CSS.escape?CSS.escape(k):k)+'"]');if(it)setQ(it,pend[k]);mark()}
    });
  }
  /* "+ Add" inside the drawer: show the new line straight away, the real cart replaces it a moment later */
  function preAdd(b){
    var up=b.closest('.amk-up'),o=cur();if(!up||!o||!o.contains(up))return;
    var list=o.querySelector('.amk-items');
    if(list){
      var li=document.createElement('li');li.className='amk-item';li.setAttribute('data-q','1');li.style.pointerEvents='none';
      li.innerHTML='<span class="amk-item__img"></span><div class="amk-item__info"><div class="amk-item__top"><span class="amk-item__t"></span></div><div class="amk-item__row"><div class="amk-qty"><button type="button" disabled>&minus;</button><span>1</span><button type="button" disabled>+</button></div><p class="amk-item__p"></p></div></div>';
      var im=up.querySelector('.amk-up__img img'),t=up.querySelector('.amk-up__t'),pr=up.querySelector('.amk-up__p');
      if(im)li.querySelector('.amk-item__img').appendChild(im.cloneNode());
      li.querySelector('.amk-item__t').textContent=t?t.textContent:'';if(pr)li.querySelector('.amk-item__p').innerHTML=pr.innerHTML;
      list.appendChild(li);
    }
    up.style.display='none';var row=up.parentNode;
    if(row&&![].some.call(row.children,function(c){return c.style.display!=='none'})){var w=row.closest('.amk-ups');if(w)w.style.display='none'}
    var n=o.querySelector('.amk__title span');if(n)n.textContent=(parseInt(n.textContent,10)||0)+1;
    mark();
  }
  function load(){
    if(loading){again=true;return}
    loading=true;again=false;var at=mseq;
    fetch(window.location.pathname+'?section_id='+SID,{cache:'no-store',credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){
      if(at===mseq&&!again){if(parse(h))refresh();else if(boostHTML===null)boostHTML=''}
    }).catch(function(){}).then(function(){loading=false;if(again){again=false;load()}});
  }
  document.addEventListener('click',function(e){
    var t=e.target,b=t.closest('[data-am-add]');
    if(b){e.preventDefault();if(b.disabled)return;preAdd(b);window.amAdd(b.getAttribute('data-am-add'),b);return}
    if(t.closest('[data-amk-close]')){var d=document.querySelector('cart-drawer-component');if(d&&typeof d.close==='function'){d.close()}else{var cb=document.querySelector('.cart-drawer__close-button');if(cb)cb.click()}return}
    var it=t.closest('.amk-item');if(!it)return;
    var key=it.getAttribute('data-key'),q=+it.getAttribute('data-q');
    var qb=t.closest('[data-amk-q]');
    if(qb){var n=Math.max(0,q+(+qb.getAttribute('data-amk-q')));if(n===q)return;setQ(it,n);if(!n)it.style.display='none';queue(key,n,!n);return}
    if(t.closest('[data-amk-rm]')){it.style.display='none';queue(key,0,true)}
  });
  /* changes made elsewhere (theme forms, other apps): fetch the drawer straight away */
  document.addEventListener('cart:update',function(e){var d=e.detail&&e.detail.data;if(d&&d.source==='am-add')return;load()});
  function init(){
    var dlg=document.querySelector('.cart-drawer__dialog');
    if(dlg&&'MutationObserver' in window){new MutationObserver(function(){if(boostHTML===null){load();return}if(!cur())place()}).observe(dlg,{childList:true,subtree:true,attributes:true,attributeFilter:['open']})}
    if('requestIdleCallback' in window)requestIdleCallback(function(){load()},{timeout:2500});else setTimeout(load,1200);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();